import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawTwitterIcon from "./RawTwitterIcon.svg.jsx";

const TwitterIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawTwitterIcon} {...props} />;
});

export default TwitterIcon;
